import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalBody,
    Box,
    Text,
    Heading,
    Input,
    Textarea,
    Button,
    Grid,
    useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Logo from "../../assets/svg/logo.svg";

export default function ContactUsModal({ isOpen, onClose }) {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        company: "",
        inquiry: "",
        message: "",
    });

    const [isLoading, setIsLoading] = useState(false);
    const toast = useToast();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        if (
            !formData.name ||
            !formData.email ||
            !formData.phone ||
            !formData.company ||
            !formData.inquiry ||
            !formData.message
        ) {
            toast({
                title: "Error",
                description: "Please fill out all required fields",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-left"
            });
            return false;
        }

        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(formData.email)) {
            toast({
                title: "Invalid Email",
                description: "Please enter a valid email address.",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-left",
            });
            return false;
        }

        return true;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;
        setIsLoading(true); // Start loading
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/contact`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const data = await res.json();
            if (res.ok) {
                toast({
                    title: "Success",
                    description: "Message sent successfully!",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-left"
                });
            } else {
                toast({
                    title: "Failed",
                    description: data.message || "Failed to send message.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-left"
                });
            }
        } catch (err) {
            console.error("Error sending contact form:", err);
            toast({
                title: "Error",
                description: "Something went wrong. Please try again.",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-left"
            });
        }
        setIsLoading(false); // Stop loading
        setFormData({
            name: "",
            email: "",
            phone: "",
            company: "",
            inquiry: "",
            message: "",
        });

        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="6xl">
            <ModalOverlay />
            <ModalContent borderRadius="lg" p={6}>
                <ModalCloseButton />
                <ModalBody>
                    <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={10}>
                        <Box>
                            <img style={{ cursor: "pointer" }} src={Logo} alt="logo" />
                            <Heading size="lg" mb={3}>
                                Get in Touch with SmsFlash
                            </Heading>
                            <Text mb={4}>
                                Let's create solutions together. Reach out to discuss your goals and how we can help.
                            </Text>
                            <Box mb={3}>
                                <Text fontWeight="bold">USA</Text>
                                <Text>Wilmington, USA</Text>
                                <Text>📞 17608180328</Text>
                            </Box>
                            <Box mb={3}>
                                <Text fontWeight="bold">Address:</Text>
                                1007 N Orange St. 4th Floor ste 1382, Wilmington, USA 19801
                            </Box>
                            <Box mt={4}>
                                <iframe
                                    title="Office Map"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d105588.09165906922!2d-77.87337945!3d34.20698345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89a9f5a20debaed5%3A0x5e66493884093032!2sWilmington%2C%20NC%2C%20USA!5e0!3m2!1sen!2sin!4v1745908121685!5m2!1sen!2sin"
                                    width="100%"
                                    height="250"
                                    style={{ borderRadius: "8px" }}
                                    loading="lazy"
                                />
                            </Box>
                        </Box>

                        <Box>
                            <Input
                                name="name"
                                placeholder="Name"
                                value={formData.name}
                                onChange={handleChange}
                                mb={3}
                            />
                            <Input
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                mb={3}
                            />
                            <Input
                                name="phone"
                                placeholder="Phone Number"
                                value={formData.phone}
                                onChange={handleChange}
                                mb={3}
                            />
                            <Input
                                name="company"
                                placeholder="Company Name"
                                value={formData.company}
                                onChange={handleChange}
                                mb={3}
                            />
                            <Input
                                name="inquiry"
                                placeholder="Inquiry Type"
                                value={formData.inquiry}
                                onChange={handleChange}
                                mb={3}
                            />
                            <Textarea
                                name="message"
                                placeholder="Your Message"
                                value={formData.message}
                                onChange={handleChange}
                                mb={3}
                            />
                            <Button
                                colorScheme="purple"
                                width="full"
                                bgGradient="linear(to-r, #390EF7, #9244F4)"
                                onClick={handleSubmit}
                                isLoading={isLoading} // This will display the spinner while submitting
                                loadingText="Sending..."
                            >
                                Send Message
                            </Button>
                        </Box>
                    </Grid>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
